import { bindRequestLogic } from './utils'
import Types from '../actionTypes/companyPerLink'
import { companyPerLinkAPI } from '../api'

const getCompanyPersLink = bindRequestLogic({
  clientFunc: companyPerLinkAPI.getCompanyPersLink,
  type: Types.GET_COMPANY_PERS_LINK_REQUEST,
  successType: Types.GET_COMPANY_PERS_LINK_SUCCESS,
  failType: Types.GET_COMPANY_PERS_LINK_FAILED,
  isQueryParam: true
})

const addCompanyPerLink = bindRequestLogic({
  clientFunc: companyPerLinkAPI.addCompanyPerLink,
  type: Types.ADD_COMPANY_PER_LINK_REQUEST,
  successType: Types.ADD_COMPANY_PER_LINK_SUCCESS,
  failType: Types.ADD_COMPANY_PER_LINK_FAILED
})

const updateCompanyPerLink = bindRequestLogic({
  clientFunc: companyPerLinkAPI.updateCompanyPerLink,
  type: Types.UPDATE_COMPANY_PER_LINK_REQUEST,
  successType: Types.UPDATE_COMPANY_PER_LINK_SUCCESS,
  failType: Types.UPDATE_COMPANY_PER_LINK_FAILED
})

const deleteCompanyPerLink = bindRequestLogic({
  clientFunc: companyPerLinkAPI.deleteCompanyPerLink,
  type: Types.DELETE_COMPANY_PER_LINK_REQUEST,
  successType: Types.DELETE_COMPANY_PER_LINK_SUCCESS,
  failType: Types.DELETE_COMPANY_PER_LINK_FAILED
})

const getCompaniesPersLinkManufacturer = bindRequestLogic({
  clientFunc: companyPerLinkAPI.getCompaniesByLinkType,
  type: Types.GET_COMPANIES_PERS_LINK_MANUFACTURER_REQUEST,
  successType: Types.GET_COMPANIES_PERS_LINK_MANUFACTURER_SUCCESS,
  failType: Types.GET_COMPANIES_PERS_LINK_MANUFACTURER_FAILED
})

const getCompaniesPersLinkSubcontractor = bindRequestLogic({
  clientFunc: companyPerLinkAPI.getCompaniesByLinkType,
  type: Types.GET_COMPANIES_PERS_LINK_SUBCONTRACTOR_REQUEST,
  successType: Types.GET_COMPANIES_PERS_LINK_SUBCONTRACTOR_SUCCESS,
  failType: Types.GET_COMPANIES_PERS_LINK_SUBCONTRACTOR_FAILED
})

export default [
  getCompanyPersLink,
  deleteCompanyPerLink,
  updateCompanyPerLink,
  addCompanyPerLink,
  getCompaniesPersLinkManufacturer,
  getCompaniesPersLinkSubcontractor
]
